import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  pitch: require("../../../assets/wc/images/pitch_goal_fcb.png"),
  ball: require("../../../assets/wc/images/ball.png"),
};

export default assets;
